import { GridStackLayout } from './GridStackLayout';

function createGridStackApi(gridStack: GridStackLayout, ref: any) {
    return {
        // The old engine never removed layouts from ItemsManager (leak) and
        // GridStackLayout has no destroy; gridstack's own destroy (keeping the
        // Blazor-owned DOM) is the correct deterministic cleanup.
        dispose: () => gridStack.grid?.destroy?.(false),

        // NOTE: GridStackLayout has never had an update method — the old
        // updateGridStackByRef global would throw if called (pre-existing dead).
        // Kept for parity with GridStackJS.Update.
        update: (id: any, position: any) => (gridStack as any).update(ref, id, position),

        removeElement: (id: string) => gridStack.removeWidget(id),

        appendElement: (id: string) => gridStack.appendElement(ref, id)
    };
}

export function createGridStackLayout(ref: any, context: any) {
    let gridStack = new GridStackLayout();
    gridStack.layout(ref, context);
    return createGridStackApi(gridStack, ref);
}

// Standalone DOM utility, not bound to a layout instance.
export function scrollToElementId(elementId: any) {
    console.info('scrolling to element', elementId);
    let element = document.getElementById(elementId);
    if (!element) {
        console.warn('element was not found', elementId);
        return false;
    }
    element.scrollIntoView();
    return true;
}
